import React, { useEffect, useState } from "react";
import { VerdictBadge } from "./VerdictBadge";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Activity } from "lucide-react";

/**
 * Marquee ticker — an endlessly-scrolling strip of the latest verdicts.
 * Duplicated content + CSS animation for seamless loop.
 */
export function VerdictTicker() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/trending").then((r) => setItems(r.data.slice(0, 10))).catch(() => {});
        const t = setInterval(() => {
            api.get("/trending").then((r) => setItems(r.data.slice(0, 10))).catch(() => {});
        }, 60000);
        return () => clearInterval(t);
    }, []);

    if (items.length === 0) return null;

    // Duplicate the array so the marquee loops seamlessly.
    const doubled = [...items, ...items];

    return (
        <div
            className="relative border-y border-white/10 bg-[hsl(var(--card))]/50 overflow-hidden py-3"
            data-testid="verdict-ticker"
        >
            <div className="flex items-center gap-6 marquee-track hover:[animation-play-state:paused]" style={{ width: "max-content" }}>
                <div className="flex items-center gap-2 pl-6 pr-2 shrink-0 text-[10px] uppercase tracking-widest text-primary font-bold">
                    <Activity className="h-3 w-3 pulse-dot" /> Live
                </div>
                {doubled.map((tc, i) => (
                    <Link
                        key={`${tc.check_id}-${i}`}
                        to={`/check/${tc.check_id}`}
                        className="flex items-center gap-3 shrink-0 hover:opacity-80 transition-opacity"
                        data-testid={`ticker-item-${i}`}
                    >
                        <VerdictBadge verdict={tc.verdict} confidence={tc.confidence} size="sm" />
                        <span className="text-sm text-accent/90 max-w-[420px] truncate">
                            &ldquo;{tc.claim}&rdquo;
                        </span>
                        <span className="text-white/20">·</span>
                    </Link>
                ))}
            </div>
        </div>
    );
}
